export default __webpack_public_path__ + "static/traditional-bdcbb59f1a9904776086775e864b95cc.webp";